import styled from '@emotion/styled'

export const OfferName = styled.div`
  color: black;
  font-family: Roboto;
  font-size: 1.375rem;
  margin: 1rem 0;
`
